module.exports = __webpack_public_path__ + "static/media/project-reference.81a878d9.png";